import Vue from 'vue/dist/vue.esm.js'


export default Vue.component( 'estimate_table', {
  template: '#estimateTable',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    is_child2 : Boolean,
    formdata: Object
  },
  data () {
    return {
      payment: this.formdata.payment,
      payment_store: this.formdata.store,
      children: [
        {
          name: '1人目',
          popy: this.formdata.popy,
          popyname: this.popyname( this.formdata.popy ),
          popy_total: 0,
          pke: this.formdata.pke,
          pkename: this.pkename( this.formdata.pke ),
          pke_total: 0,
          start: this.formdata.start,
          popypen: 'ポピペン',
          no_popypen: this.formdata.popypen,
          popypen_total: 3300,
        },
        {
          name: '2人目',
          popy: this.formdata.c2popy,
          popyname: this.popyname( this.formdata.c2popy ),
          popy_total: 0,
          pke: this.formdata.c2pke,
          pkename: this.pkename( this.formdata.c2pke ),
          pke_total: 0,
          start: this.formdata.c2start,
          popypen: 'ポピペン',
          no_popypen: this.formdata.c2popypen,
          popypen_total: 3300,
        }
      ]
    }
  },
  watch: {
    // この関数は formdata が変わるごとに実行されます。
    formdata: {
      immidiate: true,
      handler() {
        this.payment = this.formdata.payment,
        this.payment_store = this.formdata.store,

        this.children[0].popy = this.formdata.popy
        this.children[0].popyname = this.popyname( this.formdata.popy )
        this.children[0].pke = this.formdata.pke
        this.children[0].pkename = this.pkename( this.formdata.pke )
        this.children[0].no_popypen = (this.formdata.popypen)? this.formdata.popypen : ''
        this.children[0].start = this.formdata.start

        this.children[1].popy = this.formdata.c2popy
        this.children[1].popyname = this.popyname( this.formdata.c2popy )
        this.children[1].pke = this.formdata.c2pke
        this.children[1].pkename = this.pkename( this.formdata.c2pke )
        this.children[1].no_popypen = (this.formdata.c2popypen)? this.formdata.c2popypen : ''
        this.children[1].start = this.formdata.c2start
      },
      deep: true
    }
  },
  mounted () {
  },
  computed: {
    discount (){
      let c1_popy_total = this.children[0].popy_total
      let c2_popy_total = this.children[1].popy_total
      let c1_pke_total = this.children[0].pke_total
      let c2_pke_total = this.children[1].pke_total

      const discountTable = { // 各学年の一ヶ月単価(年払い割引)
        'ももちゃん': 1425,
        'きいどり': 1425,
        'あかどり': 1425,
        'あおどり': 1425,
        '小学ポピー1年生': 2980,
        '小学ポピー2年生': 3300,
        '小学ポピー3年生': 3700,
        '小学ポピー4年生': 3900,
        '小学ポピー5年生': 4300,
        '小学ポピー6年生': 4500,
        '中学ポピー1年生': 4980,
        '中学ポピー2年生': 5200,
        '中学ポピー3年生': 5400,
        'pkeレベル1': 1595.5,
        'pkeレベル2': 1595.5,
        'pkeレベル3': 1595.5,
      }

      if( this.payment == '銀行振込（年払い）' ) {
        let start1 = parseInt( this.children[0].start.replace(/^(\d)月号.+$/,'$1') ) || 1;
        let start2 = parseInt( this.children[1].start.replace(/^(\d)月号.+$/,'$1') ) || 1;
        let leastMonth1 = (start1)? 12 - ( ( 8 + start1 ) % 12 ): 1;
        let leastMonth2 = (start2)? 12 - ( ( 8 + start2 ) % 12 ): 1;
        let c1_popy_discount = discountTable[ this.children[0].popy ] * leastMonth1 || 0;
        let c2_popy_discount = discountTable[ this.children[1].popy ] * leastMonth2 || 0;
        let c1_pke_discount = discountTable[`pke${this.children[0].pke}`] * leastMonth1 || 0;
        let c2_pke_discount = discountTable[`pke${this.children[1].pke}`] * leastMonth2 || 0;
        let total = c1_popy_total + c2_popy_total + c1_pke_total + c2_pke_total;
        let discount_total = c1_popy_discount + c2_popy_discount + c1_pke_discount + c2_pke_discount;
        
        return ( total - Math.floor( discount_total ) );
      } else {
        return 0
      }
    },
    total () {
      let popy1 = 0
      let pke1 = 0
      let backnumber1 = 0
      let popypen1 = 3300
      let popy2 = 0
      let pke2 = 0
      let backnumber2 = 0
      let popypen2 = 3300
      let leastMonth1 = 1
      let leastMonth2 = 1

      const this_month = new Date().getMonth() + 1
      let start
      let start2

      const priceTable = { // 各学年の一ヶ月単価
        'ももちゃん': 1500,
        'きいどり': 1500,
        'あかどり': 1500,
        'あおどり': 1500,
        '小学ポピー1年生': 3300,
        '小学ポピー2年生': 3600,
        '小学ポピー3年生': 4100,
        '小学ポピー4年生': 4300,
        '小学ポピー5年生': 4700,
        '小学ポピー6年生': 5000,
        '中学ポピー1年生': 5500,
        '中学ポピー2年生': 5700,
        '中学ポピー3年生': 5900,
        'pkeレベル1': 1680,
        'pkeレベル2': 1680,
        'pkeレベル3': 1680,
      }

      if( this.children[0].start ){
        start = parseInt( this.children[0].start.replace(/^(\d)月号.+$/,'$1') );
        leastMonth1 = 12 - ( ( 8 + start ) % 12 );
      }
      if( this.children[1].start ){
        start2 = parseInt( this.children[1].start.replace(/^(\d)月号.+$/,'$1') );
        leastMonth2 = 12 - ( ( 8 + start2 ) % 12 );
      }

      // ベース金額(24新価格)
      popy1 += priceTable[ this.children[0].popy ] || 0;

      if( this.payment == '銀行振込（年払い）' ){
        popy1 = popy1 * leastMonth1
        this.children[0].start += '〜 3月号'
      }else if( start && start == this_month ){
        backnumber1 = popy1
        popy1 = popy1 + backnumber1
        this.children[0].start += '（次月号も含む）'
      }

      // ベース金額(24新価格)
      popy2 += priceTable[ this.children[1].popy ] || 0;

      if( this.payment == '銀行振込（年払い）' ){
        popy2 = popy2 * leastMonth2
        this.children[1].start += '〜 3月号'
      }else if( start2 && start2 == this_month ){
        backnumber2 = popy2
        popy2 = popy2 + backnumber2
        this.children[1].start += '（次月号も含む）'
      }

      pke1 += priceTable[ `pke${this.children[0].pke}` ] || 0;

      if( this.payment == '銀行振込（年払い）' ) pke1 = pke1 * leastMonth1;

      pke2 += priceTable[ `pke${this.children[1].pke}` ] || 0;

      if( this.payment == '銀行振込（年払い）' ) pke2 = pke2 * leastMonth2;

      if( !this.children[0].pke || this.children[0].no_popypen ) popypen1 = 0
      if( !this.children[1].pke || this.children[1].no_popypen ) popypen2 = 0

      this.children[0].popy_total = popy1
      this.children[1].popy_total = popy2
      this.children[0].pke_total = pke1
      this.children[1].pke_total = pke2
      this.children[0].popypen_total = popypen1
      this.children[1].popypen_total = popypen2
      
      return popy1 + pke1 + popypen1 + popy2 + pke2 + popypen2
    }
  },
  methods: {
    popyname (key) {
      const popyname = {
        'ももちゃん' : 'ももちゃん　　¥1,500/月',
        'きいどり' : 'きいどり　¥1,500/月',
        'あかどり' : 'あかどり　¥1,500/月',
        'あおどり' : 'あおどり　¥1,500/月',
        '小学ポピー1年生' : '小学ポピー1年　¥3,300/月',
        '小学ポピー2年生' : '小学ポピー2年　¥3,600/月',
        '小学ポピー3年生' : '小学ポピー3年　¥4,100/月',
        '小学ポピー4年生' : '小学ポピー4年　¥4,300/月',
        '小学ポピー5年生' : '小学ポピー5年　¥4,700/月',
        '小学ポピー6年生' : '小学ポピー6年　¥5,000/月',
        '中学ポピー1年生' : '中学ポピー1年　¥5,500/月',
        '中学ポピー2年生' : '中学ポピー2年　¥5,700/月',
        '中学ポピー3年生' : '中学ポピー3年　¥5,900/月',
        'ENGLISHのみ' : 'ENGLISHのみ'
      }
      return popyname[key]
    },
    pkename (key) {
      const pkename = {
        'レベル1' : 'ポピー Kids English ¥1,680/月',
        'レベル2' : 'ポピー Kids English ¥1,680/月',
        'レベル3' : 'ポピー Kids English ¥1,680/月',
      }
      return pkename[key]
    },
    jpyen_format (num) {
      const formatter = new Intl.NumberFormat('ja-JP')
      return '¥'+formatter.format(num)
    }
  }
})


